var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
     opacity: .9,
     background: 'linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)), url(' + _vm.blockField.image.data +'&fit=crop&w=1920&q=80) no-repeat left center'
   }),attrs:{"id":"largeImage"}},[_c('v-container',{staticClass:"fill-height justify-center"},[_c('div',{staticClass:"description-box",attrs:{"align":"center"}},[_vm._t("image"),_c('h1',{staticClass:"text-center"},[_vm._t("title")],2),_c('h3',[_vm._t("subtitle")],2)],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }